// vue
import { ref } from '@vue/composition-api';

// hooks
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { PinzoneCategory, PinzoneCategorySummary } from '@/vue3/api/models';

export const usePinzoneCategoryService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive
    const pinzoneCategories = ref<PinzoneCategory[]>([]);

    const getAllPinzoneCategorySummaries = async (
        courseSchemaId: number,
    ): Promise<PinzoneCategorySummary[]> => {
        const res = await axios.get(`${apiUrl}/category/summary`);
        return res.data;
    };

    const getAllPinzoneCategory = async (): Promise<PinzoneCategory[]> => {
        const res = await axios.get(`${apiUrl}/category`);
        pinzoneCategories.value = res.data;
        return res.data;
    };

    const getPinzoneCategory = async (id: number): Promise<PinzoneCategory> => {
        const res = await axios.get(`${apiUrl}/category/${id}`);
        return res.data;
    };

    const createPinzoneCategory = async (
        pinzoneCategory: PinzoneCategory,
    ): Promise<PinzoneCategory> => {
        const res = await axios.post(`${apiUrl}/category`, pinzoneCategory);
        return res.data;
    };

    const updatePinzoneCategory = async (
        pinzoneCategory: PinzoneCategory,
    ): Promise<PinzoneCategory> => {
        const res = await axios.put(`${apiUrl}/category`, pinzoneCategory);
        return res.data;
    };

    const deletePinzoneCategory = async (
        id: number,
    ): Promise<PinzoneCategory> => {
        const res = await axios.deleteId(`${apiUrl}/category/${id}`);
        return res.data;
    };

    return {
        pinzoneCategories,
        getAllPinzoneCategorySummaries,
        getAllPinzoneCategory,
        getPinzoneCategory,
        createPinzoneCategory,
        updatePinzoneCategory,
        deletePinzoneCategory,
    };
};
